import { useEffect, useState } from "react";

export function useCountdown(targetDate) {
  const targetMs = targetDate instanceof Date ? targetDate.getTime() : null;
  const getRemaining = () => (targetMs ? Math.max(0, targetMs - Date.now()) : null);
  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    if (!targetMs) {
      setRemaining(null);
      return undefined;
    }
    const tick = () => setRemaining(Math.max(0, targetMs - Date.now()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [targetMs]);

  return remaining;
}
